module.exports = __webpack_public_path__ + "img/clipboard.5d5c542f.svg";